import React from "react";
import { useTranslation } from "react-i18next";
import { Icon, Link, Text } from "src/components";
import { getTextColorFromHex, getTextColorFromHSL } from "src/util/util";
import styled from "styled-components";
import { EditDataProps } from ".";
import { Row } from "./gridElements";
import toast from 'react-hot-toast';
import { observer } from "mobx-react";


const StatusRow = styled(Row)`
  background-color: ${props => props.color};
  border-left:      ${props => `1px solid ${props.color}`};
  border-right:     ${props => `1px solid ${props.color}`};
  padding-left:     1rem;
  padding-right:    1rem;
  padding-top:      0.4rem;
  padding-bottom:   0.4rem;
  justify-content:  space-between;
  align-items:      center;
`;

const PathName = styled.span`
  max-width:     60rem;
  overflow:      hidden;
  white-space:   nowrap;
  text-overflow: ellipsis;
  :not(:first-child):before {
    content: '>';
  }
`

export const StatusBar = observer((props: EditDataProps): JSX.Element => {
  const { data } = props;
  const { t, i18n } = useTranslation();
  const dataPath = (<>{data.getDisplayPath.split(" > " + " ").map(t => (<PathName key={t}>{t}</PathName>))}</>);

  return (
    <StatusRow height="fit-content" color={data.getStatusColor}>
      <Text color={getTextColorFromHSL(data.getStatusColor)}>{t(data.getStatus)}</Text>
      <Link 
        color   = {getTextColorFromHSL(data.getStatusColor)}
        onClick = {() => {
          if(data.isNew) {
            props.onClose();
          } else {
            navigator.clipboard.writeText(data.getRoutingPath);
            toast.success(t("copied_to_clipboard"));
          }
        }} 
      >
        <div style={{display: "flex", alignItems: "center"}}>
          {data.isNew ? t("discard_new") : dataPath}
          <div style={{marginLeft: "0.6rem"}}>
            <Icon 
              iconId = {data.isNew ? "delete" : "copy"}
              color  = {getTextColorFromHSL(data.getStatusColor)}
              size   = "default"
            />
          </div>
        </div>
      </Link> 
    </StatusRow>
  );
});